// extracted by mini-css-extract-plugin
module.exports = {"center":"center__styles-module--2nMiw","heading-ribbon":"heading-ribbon__styles-module--3m7Aj","headingRibbon":"heading-ribbon__styles-module--3m7Aj"};